<template>
  <div class="ctrl-btns" :class="disabled && 'disabled'">
    <a
      :title="$locale('global.delete')"
      v-if="isShowDel"
      @click="ctrlFunc(del)"
    ><i class="el-icon-minus">&nbsp;</i></a>
    <a
      :title="$locale('global.add')"
      v-if="isShowAdd"
      @click="ctrlFunc(add)"
    ><i class="el-icon-plus">&nbsp;</i></a>
  </div>
</template>

<script>
export default {
  name: "ctrl-btns",
  props: {
    fieldData: {
      required: true,
      type: Array,
    },
    index: {
      required: true,
      type: Number,
    },
    authority: {
      type: Object,
      default: () => ({
        add: true,
        del: true,
      }),
    },
    newestIsOnTop: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    factDispList: Array,
  },
  data() {
    return {
      add: "ADD",
      del: "DEL",
    };
  },
  computed: {
    topIndex() {
      const _topIdx = this.fieldData.findIndex(_item => !_item.toBeDelete);
      return _topIdx;
    },
    isShowDel() {
      return (this.factDispList ? this.factDispList.length > 1 : this.fieldData.length > 1) && this.authority.del;
    },
    isShowAdd() {
      return (this.newestIsOnTop ? this.factDispList ? this.index === this.topIndex : this.index === 0 : this.index === this.fieldData.length - 1) && this.authority.add;
    },
  },
  methods: {
    ctrlFunc(_op) {
      this.$emit("clickAction", _op);
    }
  },
};
</script>

<style scoped lang="less">
.ctrl-btns {
  > a {
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    border: 1px solid @primary-light-grey;
    border-radius: 3px;
    margin-top: 40px;
    margin-right: 12px;
    line-height: 40px;
    text-align: center;

    i {
      color: @primary-dark-grey;
      font-weight: bold;
    }

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      border-color: @primary-yellow;

      i {
        color: @primary-yellow;
      }
    }
  }
  
  &.disabled {
    cursor: not-allowed;
    
    > a {
      pointer-events: none;
      background-color: #F5F7FA;
      color: #C0C4CC;
    }
  }
}

.alertMsg-block {
  .ctrl-btns > a {
    margin-top: 0;
  }
}
</style>
